import React from 'react';
import styled, { css } from 'styled-components';
import { Box, VisuallyHidden } from '@99designs/emu';
import { spaces, typography } from '@99designs/emu/settings';
import { IconLeft1, IconRight1 } from '@99designs/icons';
import { OnWhiteIconButton } from '@99designs/spa-common';

interface PaginationItemProps {
    next?: boolean;
    prev?: boolean;
}
const PaginationItem = styled.div<PaginationItemProps>`
    font-family: ${typography.fontFamilies.heading};
    font-size: ${typography.typeScale.size4}px;

    & + & {
        margin-left: ${spaces['1bu']};
    }

    ${({ prev = false, next = false }) =>
        (prev || next) &&
        css`
            width: 25px;
        `}
`;

const noop: () => void = () => undefined;

interface PaginationNavigationProps {
    currentPageNumber?: number;
    totalNumberOfPages: number;
    navNext?: () => void;
    navPrev?: () => void;
}

function PaginationNavigation({
    currentPageNumber,
    totalNumberOfPages,
    navNext,
    navPrev,
}: PaginationNavigationProps) {
    if (!currentPageNumber) return null;

    return (
        <Box display="flex" alignItems="center">
            <PaginationItem prev>
                <OnWhiteIconButton
                    title={__('Previous (left arrow)')}
                    disabled={!navPrev}
                    onClick={navPrev ? navPrev : noop}
                >
                    <IconLeft1 width="2em" height="2em" />
                    <VisuallyHidden>{__('Previous (left arrow)')}</VisuallyHidden>
                </OnWhiteIconButton>
            </PaginationItem>
            <PaginationItem>
                <span>
                    {currentPageNumber} / {totalNumberOfPages}
                </span>
            </PaginationItem>
            <PaginationItem next>
                <OnWhiteIconButton
                    title={__('Next (right arrow)')}
                    disabled={!navNext}
                    onClick={navNext ? navNext : noop}
                >
                    <IconRight1 width="2em" height="2em" />
                    <VisuallyHidden>{__('Next (right arrow)')}</VisuallyHidden>
                </OnWhiteIconButton>
            </PaginationItem>
        </Box>
    );
}

export default PaginationNavigation;
